<template>
    <el-radio-group v-model="modelValue" @change="change">
        <el-radio-button v-for="(item, i) in options" :key="i" :label="item"></el-radio-button>
    </el-radio-group>
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String, Array, Object],
            default: "",
        },
        valueKey: {
            type: String,
            default: "value",
        },
        options: {
            type: Array,
            default: () => [],
        },
        labelField: {
            type: String,
            default: "label",
        },
        valueField: {
            type: String,
            default: "value",
        },
    },

    computed: {
        modelValue: {
            get({ value, $attrs }) {
                if ($attrs.multiple && !Array.isArray(value)) return [];
                return value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        change(selectedvalue){
            this.$emit("typechange",selectedvalue)
        }
    }
};
</script>